import { AcdcAppointmentSlot, ConsumptionAddress, Contractor } from '.';
import { GridAccessPoint } from '@/models/prosumer-declaration'

export interface CheckEanSearch {
  ean: string;
}

export enum MetersError {
  NoError = 'noError',
  NotFound = 'notFound',
  MeterIsAlreadyInDoubleFlow = 'meterIsAlreadyInDoubleFlow',
  DeliveryContractNotActive = 'deliveryContractNotActive',
  NotElectricityGridAccessPoint = 'notElectricityGridAccessPoint',
  MoreThanOneMeter = 'moreThanOneMeter',
  ReadingFrequencyNotYearly = 'readingFrequencyNotYearly',
  BudgetMeterDeactivationRequired = 'budgetMeterDeactivationRequired',
  AcdcAppointmentAlreadyScheduledWithRealisationDate = "acdcAppointmentAlreadyScheduledWithRealisationDate"
}

export interface CheckEanSmartMeterResult {
  error: MetersError;
  consumptionAddress: ConsumptionAddress;
  appointmentSlot: AcdcAppointmentSlot;
  contractor: Contractor;
}

export interface CheckEanForSmartMeterResponse {
  eanInfo: CheckEanSmartMeterResult;
  token: string;
}

export interface CheckEanForChargingStationDeclarationResponse {
  gridAccessPoint: ChargingStationDeclarationGridAccessPoint;
  token: string;
}

export interface ChargingStationDeclarationGridAccessPoint {
  consumptionAddress: ConsumptionAddress;
  ean: string;
}

export interface CheckEanForProsumerDeclarationResponse {
  gridAccessPoint: GridAccessPoint;
  token: string;
}
